const FEATURE_FLAGS = {
  ENABLE_CUSTOM_MFA: {
    key: 'ENABLE_CUSTOM_MFA',
    default: false,
    envVar: 'REACT_APP_ENABLE_CUSTOM_MFA',
    description: 'Enable custom MFA/OTP flow',
  },
  ENABLE_CARD_REPLACEMENT: {
    key: 'ENABLE_CARD_REPLACEMENT',
    default: false,
    envVar: 'REACT_APP_ENABLE_CARD_REPLACEMENT',
    description: 'Enable card replacement flow (bypasses C3Pay restriction popup)',
  },
};

const initializeFlags = () => {
  const initialized = {};

  Object.entries(FEATURE_FLAGS).forEach(([key, config]) => {
    const envValue = process.env[config.envVar];
    initialized[key] = envValue !== undefined ? envValue === 'true' : config.default;
  });

  return initialized;
};

const flags = initializeFlags();

export const isEnabled = (flagKey) => {
  if (!FEATURE_FLAGS[flagKey]) {
    console.warn(`Feature flag "${flagKey}" is not defined`);
    return false;
  }
  return flags[flagKey];
};
